export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.310.0-146045b",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
